import React from 'react'

export const CategoryCard = ({
  blogCount,
  label,
}: {
  blogCount: number
  label: string
}) => {
  return (
    <div
      className='flex flex-col justify-center items-center max-w-[160px] rounded-lg 
        py-[16px] px-[32px] bg-[#CFFBF5]'
    >
      <div className='text-lg lg:text-[32px] text-[#001A3D] font-bold '>
        {blogCount}
      </div>
      <div className='text-sm lg:text-base font-medium tracking-wide text-center'>
        {label}
      </div>
    </div>
  )
}
